import {Locale} from "next-intl";
import {SettingsNavigationProperty} from "@pata/settings";
import {getLocale, getTranslations} from "next-intl/server";

export default async function fetchMainMenu(): Promise<SettingsNavigationProperty[]> {
    const locale: Locale = await getLocale()
    const t = await getTranslations('Navigation')
    
    switch (locale) {
        default:
            return [
                { name: t("forest-management"), path: "/forest-management", htmlId: 1411 },
                { name: t("logging"), path: "/logging", htmlId: 1412 },
                { name: t("shop"), path: "https://patatimber.lv/", htmlId: 38 },
                { name: t("timber-industry"), path: "/timber-industry", htmlId: 1414 },
                { name: t("energy"), path: "/energy", htmlId: 1413 },
                { name: t("transport-and-logistics"), path: "/transport-and-logistics", htmlId: 1415 },
                { name: t("sawn-wood-trade"), path: "/sawn-wood-trade", htmlId: 1416 },
                { name: t("round-timber-trade"), path: "/round-timber-trade", htmlId: 1417 },
                { name: t("financing"), path: "/financing", htmlId: 1418 },
            ]
        case "en":
            return [
                { name: t("sawn-wood-trade"), path: "/sawn-wood-trade", htmlId: 607 },
                { name: t("round-timber-trade"), path: "/round-timber-trade", htmlId: 1142 },
                { name: t("energy"), path: "/energy", htmlId: 634 },
                { name: t("forest-management"), path: "/forest-management", htmlId: 1140 },
                { name: t("logging"), path: "/logging", htmlId: 588 },
                { name: t("shop"), path: "https://patatimber.lv/", htmlId: 589 },
                { name: t("timber-industry"), path: "/timber-industry", htmlId: 594 },
                { name: t("transport-and-logistics"), path: "/transport-and-logistics", htmlId: 603 },
                { name: t("financing"), path: "/financing", htmlId: 614 },
            ]
        case "lt":
            return [
                { name: t("forest-management"), path: "/forest-management", htmlId: 1655 },
                { name: t("logging"), path: "/logging", htmlId: 1654 },
                { name: t("shop"), path: "https://patatimber.lv/", htmlId: 1656 },
                { name: t("timber-industry"), path: "/timber-industry", htmlId: 1658 },
                { name: t("energy"), path: "/energy", htmlId: 1657 },
                { name: t("transport-and-logistics"), path: "/transport-and-logistics", htmlId: 1659 },
                { name: t("sawn-wood-trade"), path: "/sawn-wood-trade", htmlId: 1661 },
                { name: t("round-timber-trade"), path: "/round-timber-trade", htmlId: 1660 },
                { name: t("financing"), path: "/financing", htmlId: 1662 },
            ]
        case "cn":
            return [
                { name: t("forest-management"), path: "/forest-management", htmlId: 1420 },
                { name: t("logging"), path: "/logging", htmlId: 1419 },
                { name: t("shop"), path: "https://patatimber.lv/", htmlId: 1421 },
                { name: t("timber-industry"), path: "/timber-industry", htmlId: 1422 },
                { name: t("energy"), path: "/energy", htmlId: 1423 },
                { name: t("transport-and-logistics"), path: "/transport-and-logistics", htmlId: 1424 },
                { name: t("sawn-wood-trade"), path: "/sawn-wood-trade", htmlId: 1425 },
                { name: t("round-timber-trade"), path: "/round-timber-trade", htmlId: 1426 },
                { name: t("financing"), path: "/financing", htmlId: 1427 },
            ]
    }
}